import { gql } from "@apollo/client";

const schema = {
  get: {
    name: 'moduleType',
    serviceName: 'graphql',
    query: gql`
      query moduleType($ids: [String]) {
        moduleType(ids: $ids) {
          data {
            title
            details
          }
        }
      }
    `,
  },
  update: {
    name: 'updateModuleType',
    serviceName: 'admin',
    query: gql`
      mutation updateModuleType($ids: [String]!, $title: String, $details: String) {
        updateModuleType(ids: $ids, title: $title, details: $details) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
